<template>
  <PageContainer id="paidout">
    <div class="page-content">
      <div class="title">What's the catch?</div>
      <div class="title small black">There is no catch! Here's what happens when you hit your goal:</div>

      <ul class="steps">
        <li>
          <span class="step-number">1. </span><span class="step-content">Use our app to weigh out anytime during the two-week window at the end of your HealthyWager.</span>
        </li>
        <li>
          <span class="step-number">2. </span><span class="step-content">Upload a photo of your ID to confirm it's you, and provide an electronic signature that you didn't cheat.</span>
        </li>
        <li>
          <span class="step-number">3. </span><span class="step-content">In some cases, the IRS requires us to have you fill out a Form W-9 (a simple online tax form - takes about 30 seconds).</span>
        </li>
        <li>
          <span class="step-number">4. </span><span class="step-content">Choose payout method: PayPal or check.</span>
        </li>
        <li>
          <span class="step-number">5. </span><span class="step-content">We pay out quickly (3-day-average for PayPal / 7-day-average for checks)!</span>
        </li>
      </ul>

      <div class="box">
        <div class="title">In the last 12 months we've paid out</div>
        <div class="value">$9,929,136.38</div>
      </div>
    </div>

    <div class="footer-container">
      <ButtonNext :onClick="next" :isDisabled="false" :text="'Next'" />
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ButtonNext from '../../shared/components/ButtonNext';
import ProgressBar from '../../shared/components/ProgressBar';
import { delayedTransition, ROUTE_NAMES } from '../router';
import Trackeable from '../../Trackeable';
import ProgressFull from '../mixins/ProgressFull';

export default {
  components: {
    PageContainer,
    ButtonNext,
    ProgressBar
  },
  mixins: [Trackeable, ProgressFull],
  methods: {
    next() {
      delayedTransition(this.$router, ROUTE_NAMES.TopRatedApps)
    }
  }
}
</script>
